import { InlineEmptyStateOnboarding } from "@octopusdeploy/design-system-components";
import React from "react";
import { NoArgoCDApplicationsIllustration } from "~/areas/infrastructure/components/ArgoCDInstances/components/NoArgoCDApplicationsIllustration";
import { ExternalLinkSlugs } from "../ArgoCDConstants";
type EmptyStateNoArgoCDApplicationsProps = {
    onGenerateAnnotationsClick: () => void;
};
export const EmptyStateNoArgoCDApplications = (props: EmptyStateNoArgoCDApplicationsProps) => (<InlineEmptyStateOnboarding illustration={"Custom"} image={<NoArgoCDApplicationsIllustration />} title={"You don't have any Argo CD applications yet"} description={"Start by adding annotations to your Argo CD applications to map them to Octopus projects, environments and tenants"} actions={{
        primary: {
            type: "button",
            label: "Generate annotations",
            onClick: props.onGenerateAnnotationsClick,
        },
    }} learnMore={{
        label: "Docs: Argo CD",
        path: ExternalLinkSlugs.AnnotationsDocs,
    }}/>);
